import { Divider, ListItemIcon, ListItemText } from "@mui/material";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../State/Store";
import { logout } from "../State/AuthSlice";

interface menuItem {
  name: string;
  path: string;
  icon: any;
  activeIcon: any;
}

interface DrawerListProps {
  menu: menuItem[];
  menu2: menuItem[];
  toggleDrawer: () => void;
 
}

export const DrawerList = ({ menu, menu2}: DrawerListProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
 
  const handleLogout =async () => { 
   
   await dispatch(logout(navigate))
   }

  return (
    <div className="">
      {/* giving border right to seperate left and right sides */}
      <div  className={`flex flex-col  justify-between min-h-[90vh] w-[300px]  border-r py-5`}>
        <div className="space-y-2">
          {menu.map((item: menuItem, index: number) => {
            return (
              <div
                onClick={() => {
                
                  if(item.path==="/")
                  {
                    handleLogout()
                  }else{

                    navigate(item.path)
                  }
                }}
                className="pr-9 cursor-pointer"
                key={index}
              >
                <div
                  className={`${
                    item.path === location.pathname
                      ? "bg-primary text-white"
                      : "text-primary"
                  } flex items-center px-5 py-3 rounded-r-full`}
                >
                  <ListItemIcon>
                    {item.path === location.pathname
                      ? item.activeIcon
                      : item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.name} />
                </div>
              </div>
            );
          })}
        </div>
        <Divider />
        <div className="space-y-2"> 
          {menu2.map((item: menuItem, index: number) => {
            return (
              <div
         
                onClick={() => {
                  if(item.path==="/")
                    {
                      handleLogout()
                    }else{
  
                      navigate(item.path)
                    }
                }}
                className="pr-9 cursor-pointer"
                key={index}
              >
                <div
                  className={`${
                    item.path === location.pathname
                      ? "bg-primary text-white"
                      : "text-primary"
                  } flex items-center px-5 py-3 rounded-r-full`}
                >
                  <ListItemIcon>
                    {item.path === location.pathname
                      ? item.activeIcon
                      : item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.name} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
   
    </div>
  );
};
